<template>
    <div>
        <h5 class="f-title">
            {{word.blocked_users}}
        </h5>

        <v-loading v-if="loading"></v-loading>

        <div
                class="row match-grid-dash"
                style="margin-top: 18px;"
                v-if="people.length"
        >
            <div v-for="user in people" class="col-md-4 col-sm-6">
                <div
                        :style="{ backgroundImage: 'url(' + user.avatar + ')' }"
                        class="grid-avatar-dashboard"
                >
                    <a :href="`/${$window.locale}/user/' + user.user_name`">
                        <div class="match-cart-dashboard">
                            <h5>{{ user.name }}</h5>
                            <unblock-button :user="user"></unblock-button>
                        </div>
                    </a>

                </div>
            </div>
        </div>

        <div v-else-if="!loading" class="alert alert-warning">
            <p>{{text.list_is_empty}}</p>
        </div>
    </div>
</template>

<script>
    import UnblockButton from "./UnblockButton";

    export default {
        name: "blocked-users-list",

        components: {
            UnblockButton
        },

        data() {
            return {
                people: [],
                word: window.word,
                text: window.text,
                loading: true,
            }
        },

        methods: {
            fetchBlockedUsers() {
                let self = this
                self.loading = true
                axios.post('/en/dashboard/blocked').then(response => {
                    this.people = response.data.data
                    self.loading = false
                })
                    .catch(error => {
                        self.loading = false
                    });
            },
        },

        async mounted() {
            await this.fetchBlockedUsers();

            Bus.$on('UserUnblocked', (userId) => {
                this.people = this.people.filter(user => user.id !== userId);
            });
        }
    };
</script>
